// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class SectionFullWidthImageCarousel extends HTMLElement {
  constructor () {
    super()

    this.carouselContainer = this.querySelector(
      '[data-el="section-full-width-image-carousel.carouselContainer"]'
    )
    this.carouselSlides = this.querySelectorAll(
      '[data-el="section-full-width-image-carousel.carouselSlide"]'
    )
    this.arrowPrev = this.querySelector(
      '[data-el="section-full-width-image-carousel.prev"]'
    )
    this.arrowNext = this.querySelector(
      '[data-el="section-full-width-image-carousel.next"]'
    )

    this.progressEl = this.querySelector(
      '[data-el="section-full-width-image-carousel.progress"]'
    )

    if (this.carouselSlides.length < 2) return

    this.carousel = this.initialiseCarousel()

    this.arrowPrev.addEventListener('click', this.handleArrowClick.bind(this))
    this.arrowNext.addEventListener('click', this.handleArrowClick.bind(this))
  }

  initialiseCarousel () {
    return new KeenSlider(this.carouselContainer, {
      loop: true,
      mode: 'snap',
      slides: this.carouselSlides,
      slidesPerView: 1,
      spacing: 0,
      move: instance => {
        if (this.progressEl) {
          const progressTrack = instance.details().progressTrack
          const progressAmount = progressTrack >= 0.9 ? 0 : progressTrack
          const movementPercentage = progressAmount * 100
          this.progressEl.style.setProperty(
            '--progress',
            `${movementPercentage}%`
          )
        }
      },
    })
  }

  handleArrowClick (e) {
    if (e.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

if (!customElements.get('full-width-image-carousel')) {
  customElements.define(
    'full-width-image-carousel',
    SectionFullWidthImageCarousel
  )
}
